<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Tesoros del Mundo Prehispánico</h2>
    <img @click="imageClicked(0)" src="galerias/gameRoom/penacho.png" class="mainphoto"/>
    <p class="photo-description">Penacho de Moctezuma. Réplica del original. Reproducción de un tocado de plumas de Quetzal y adornos de oro, de silueta semicircular. Cultura Mexica. Mide: 166 x 175 cm. Colección: Museo Nacional de Antropología. Imagen propiedad de la Mediateca INAH</p>
    <p>El penacho original se encuentra en Austria desde 1699, se exhibe en el Museo del Mundo de Viena. Se dice que esta maravillosa pieza de fue un regalo que hizo Moctezuma II a Hernán Cortés. Algunos expertos consideran que este tipo de objetos fueron utilizados por sacerdotes durante algunas ceremonias, es considerado un objeto emblemático del arte mesoamericano.</p>
    <p>En 1940, se elaboró en México una réplica para su exhibición en Museo Nacional de Antropología.</p>
    <p>Conoce más:
      <ul>
        <li><a target="_blank" href="https://www.mna.inah.gob.mx/detalle_pieza_mes.php?id=218">www.mna.inah.gob.mx</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: "GameM4",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
};
</script>
